import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { t as theme } from './theme-0fe3bd9d.js';
import { S as SpringBackdrop } from './SpringBackdrop-9110741e.js';

var css_248z$7 = ".spring-nav{-ms-flex-align:center;-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-ms-flexbox;display:flex;height:60px;position:fixed;top:0;transition-duration:.15s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);width:100%;z-index:50}@media (min-width:600px){.spring-nav{height:90px}}@media (min-width:1200px){.spring-nav{pointer-events:none}}.spring-nav__wrapper{display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.spring-nav--float{--tw-bg-opacity:1;--tw-shadow:0 5px 20px 0 rgba(115,120,216,.15);background-color:rgba(255,255,255,var(--tw-bg-opacity));box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);width:100%}@media (min-width:1200px){.spring-nav--float{height:70px}}.spring-nav a{pointer-events:auto}.spring-nav--drop-nav{margin-top:60px}@media (min-width:600px){.spring-nav--v2{height:110px}}.spring-nav--v2 a{pointer-events:none}";
styleInject(css_248z$7);

var css_248z$6 = ".spring-nav-desktop{display:none}@media (min-width:1200px){.spring-nav-desktop{margin-left:auto;margin-right:auto;padding-left:30px;padding-right:30px}@media (min-width:600px){.spring-nav-desktop{padding-left:80px;padding-right:80px}}@media (min-width:900px){.spring-nav-desktop{max-width:1280px}}@media (min-width:1200px){.spring-nav-desktop{padding-left:40px;padding-right:40px}}.spring-nav-desktop{-ms-flex-align:center;-ms-flex-pack:justify;-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:space-between;justify-content:space-between;width:100%}}.spring-nav-desktop__logo{cursor:pointer;margin-left:0;pointer-events:auto;position:relative}.spring-nav-desktop__menu{display:-webkit-flex;display:-ms-flexbox;display:flex}.spring-nav-desktop__menu-item{margin-left:40px;pointer-events:auto;transition-duration:.3s}.spring-nav-desktop__menu-item:hover{font-weight:700}.spring-nav-desktop__menu-item-inner{cursor:pointer;display:-webkit-flex;display:-ms-flexbox;display:flex}.spring-nav-desktop__menu-item-inner,.spring-nav-desktop__menu-item-title{-ms-flex-align:center;-ms-flex-pack:justify;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.spring-nav-desktop__menu-item-title{display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;position:relative}.spring-nav-desktop__menu-item-title:after{content:attr(data-text);font-weight:700;height:0;overflow:hidden;pointer-events:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;visibility:hidden}.spring-nav-desktop__menu-icon{margin-left:10px;transition-duration:.15s;transition-duration:.3s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.spring-nav-desktop__menu-item--active .spring-nav-desktop__menu-icon{--tw-rotate:180deg;-webkit-transform:var(--tw-transform);transform:var(--tw-transform)}.spring-nav-desktop__menu-item--cursor-default{cursor:default}.spring-nav-desktop__dropdown{--tw-bg-opacity:1;--tw-shadow:0 5px 20px 0 rgba(115,120,216,.15);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);cursor:default;left:0;margin-top:0;opacity:0;pointer-events:none;top:100%;visibility:hidden}.spring-nav-desktop__dropdown,.spring-nav-desktop__dropdown:before{background-color:rgba(255,255,255,var(--tw-bg-opacity));position:absolute;width:100%;z-index:-1}.spring-nav-desktop__dropdown:before{--tw-bg-opacity:1;bottom:100%;content:\"\";height:90px}.spring-nav-desktop__dropdown--show{opacity:1;pointer-events:auto;transition-duration:.15s;transition-duration:.7s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:visible}.spring-nav-desktop__dropdown-inner{--tw-bg-opacity:1;--tw-bg-opacity:0.05;position:relative}.spring-nav-desktop__dropdown-inner,.spring-nav-desktop__dropdown-inner:before{background-color:rgba(215,218,242,var(--tw-bg-opacity))}.spring-nav-desktop__dropdown-inner:before{--tw-bg-opacity:1;--tw-bg-opacity:0.2;content:\"\";height:3px;left:0;position:absolute;top:0;width:100%}.spring-nav-desktop--v2 .spring-nav-desktop__menu{display:none}.spring-nav-desktop--v2 .spring-nav-desktop__logo{cursor:default}@media (min-width:600px){.spring-nav-desktop--v2 .spring-nav-desktop__logo{width:110px}}@media (min-width:900px){.spring-nav-desktop--v2 .spring-nav-desktop__logo{width:130px}}@media (min-width:600px){.spring-nav-desktop--v2 .spring-nav-desktop__logo img{width:110px}}@media (min-width:900px){.spring-nav-desktop--v2 .spring-nav-desktop__logo img{width:130px}}";
styleInject(css_248z$6);

var css_248z$5 = "@media (min-width:1200px){.spring-menu-list-box{margin-left:auto;margin-right:auto;padding-left:30px;padding-right:30px}@media (min-width:600px){.spring-menu-list-box{padding-left:80px;padding-right:80px}}@media (min-width:900px){.spring-menu-list-box{max-width:1280px}}@media (min-width:1200px){.spring-menu-list-box{padding-left:40px;padding-right:40px}}.spring-menu-list-box{-ms-flex-pack:center;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:center;justify-content:center;padding-bottom:20px;padding-top:20px}.spring-menu-list-box__item{display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex:1 1 0%;-ms-flex:1 1 0%;flex:1 1 0%;margin-right:40px}.spring-menu-list-box__item:last-child{margin-right:0}}";
styleInject(css_248z$5);

var css_248z$4 = ".spring-menu-box{--tw-bg-opacity:0.1;--tw-border-opacity:0;border-radius:20px;border-width:1px;display:block;-webkit-flex:1 1 0%;-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:15px;padding:25px;transition-duration:.15s;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,-webkit-transform,-webkit-filter,-webkit-backdrop-filter;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-transform,-webkit-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}@media (min-width:1200px){.spring-menu-box{margin-bottom:0}}.spring-menu-box:hover{--tw-translate-y:-5px;--tw-border-opacity:1;--tw-shadow:0 4px 20px rgba(115,120,216,.15);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);-webkit-transform:var(--tw-transform);transform:var(--tw-transform)}.spring-menu-box__title{display:block;font-family:garamond-premier-pro-caption,Garamond,serif;font-size:24px;font-weight:600;line-height:32px;margin-bottom:5px}.spring-menu-box__desc{font-weight:400}";
styleInject(css_248z$4);

var tracking = {
  methods: {
    addTrackingParams(link) {
      return this.joinedTrackingParams ? `${link}?${this.joinedTrackingParams}` : link;
    }
  },
  computed: {
    joinedTrackingParams() {
      var _this$$route;
      return (_this$$route = this.$route) !== null && _this$$route !== void 0 && _this$$route.query ? Object.entries(this.$route.query).map(_ref => {
        let [key, val] = _ref;
        return `${key}=${val}`;
      }).join('&') : false;
    }
  }
};

var SpringNavMenuBoxLink = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('a', {
      staticClass: "spring-menu-box",
      class: [_vm.bgColorClass(), _vm.borderColorClass()],
      attrs: {
        "href": _vm.addTrackingParams(_vm.link),
        "target": _vm.target
      }
    }, [_c('span', {
      staticClass: "spring-menu-box__title"
    }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
      staticClass: "spring-menu-box__desc"
    }, [_vm._v(_vm._s(_vm.description))])]);
  },
  staticRenderFns: [],
  name: 'SpringNavMenuBoxLink',
  mixins: [theme, tracking],
  props: {
    link: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: ''
    }
  }
};

var SpringNavListBox = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('ul', {
      staticClass: "spring-menu-list-box"
    }, _vm._l(_vm.items, function (item, index) {
      return _c('li', {
        key: index,
        staticClass: "spring-menu-list-box__item"
      }, [_c('SpringNavMenuBoxLink', {
        attrs: {
          "link": item.link,
          "title": item.title,
          "description": item.description,
          "theme": item.theme
        },
        nativeOn: {
          "click": function ($event) {
            return _vm.$emit('click');
          }
        }
      })], 1);
    }), 0);
  },
  staticRenderFns: [],
  name: 'SpringNavListBox',
  components: {
    SpringNavMenuBoxLink
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};

var css_248z$3 = ".spring-menu-list{margin-bottom:15px}@media (min-width:1200px){.spring-menu-list{-ms-flex-pack:center;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:center;justify-content:center;margin-bottom:0;padding-bottom:20px;padding-top:20px}}.spring-menu-list__item{margin-bottom:15px;padding-left:45px}@media (min-width:1200px){.spring-menu-list__item{margin-bottom:0}}";
styleInject(css_248z$3);

var css_248z$2 = ".spring-menu-link{-ms-flex-align:center;-ms-flex-pack:justify;-webkit-align-items:center;align-items:center;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;font-weight:400;-webkit-justify-content:space-between;justify-content:space-between;position:relative}.spring-menu-link:after{content:attr(title);height:0;overflow:hidden;pointer-events:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;visibility:hidden}.spring-menu-link:after,.spring-menu-link:hover{font-weight:700}";
styleInject(css_248z$2);

var SpringNavMenuLink = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return !_vm.nuxtLink ? _c('a', {
      staticClass: "spring-menu-link",
      attrs: {
        "href": _vm.addTrackingParams(_vm.link),
        "data-text": _vm.title,
        "target": _vm.target
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click');
        }
      }
    }, [_vm._v("\n  " + _vm._s(_vm.title) + "\n")]) : _c('nuxt-link', {
      staticClass: "spring-menu-link",
      attrs: {
        "to": _vm.link,
        "data-text": _vm.title,
        "target": _vm.target
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click');
        }
      }
    }, [_vm._v("\n  " + _vm._s(_vm.title) + "\n")]);
  },
  staticRenderFns: [],
  name: 'SpringNavMenuLink',
  mixins: [tracking],
  props: {
    link: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    nuxtLink: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: ''
    }
  }
};

var SpringNavListRegular = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('ul', {
      staticClass: "spring-menu-list"
    }, _vm._l(_vm.items, function (item, index) {
      return _c('li', {
        key: index,
        staticClass: "spring-menu-list__item"
      }, [_c('SpringNavMenuLink', {
        attrs: {
          "title": item.title,
          "link": item.link
        },
        on: {
          "click": function ($event) {
            return _vm.$emit('click');
          }
        }
      })], 1);
    }), 0);
  },
  staticRenderFns: [],
  name: 'SpringNavListRegular',
  components: {
    SpringNavMenuLink
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};

var SpringNavDesktop = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "spring-nav-desktop",
      class: _vm.variantStyles
    }, [_c('div', {
      staticClass: "spring-nav-desktop__logo",
      class: _vm.logoWidth
    }, [!_vm.variant ? _c('a', {
      attrs: {
        "href": _vm.addTrackingParams(_vm.minisiteUrl),
        "target": _vm.target
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.menuLogo,
        "alt": "Spring Financial logo",
        "width": "85",
        "height": "30"
      }
    })]) : _vm.variant === 'v2' ? _c('img', {
      attrs: {
        "src": _vm.menuLogo,
        "alt": "Spring Financial logo",
        "width": "85",
        "height": "30"
      }
    }) : _vm._e()]), _vm._v(" "), !_vm.hideMenu ? _c('ul', {
      staticClass: "spring-nav-desktop__menu"
    }, _vm._l(_vm.navigation, function (nav, index) {
      return _c('li', {
        key: index,
        staticClass: "spring-nav-desktop__menu-item",
        class: {
          'spring-nav-desktop__menu-item--active': _vm.isOpen(nav),
          'spring-nav-desktop__menu-item--cursor-default': !nav.link
        },
        attrs: {
          "tabindex": nav.children ? '0' : '-1'
        },
        on: {
          "mouseenter": function ($event) {
            nav.children && _vm.openNav(index);
          },
          "mouseleave": function ($event) {
            nav.children && _vm.closeNav(index);
          },
          "keydown": function ($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            nav.children && _vm.toggleNav(index);
          }
        }
      }, [nav.children ? _c('div', {
        staticClass: "spring-nav-desktop__menu-item-inner"
      }, [_c('span', {
        staticClass: "spring-nav-desktop__menu-item-title",
        attrs: {
          "data-text": nav.title
        }
      }, [nav.link ? _c('a', {
        attrs: {
          "href": nav.link,
          "target": _vm.target
        }
      }, [_vm._v("\n            " + _vm._s(nav.title) + "\n          ")]) : _c('span', [_vm._v(_vm._s(nav.title))])]), _vm._v(" "), _c('div', {
        staticClass: "spring-nav-desktop__menu-icon"
      }, [_c('font-awesome-icon', {
        key: "angle",
        attrs: {
          "icon": ['fas', 'angle-down'],
          "size": "lg"
        }
      })], 1)]) : _c('a', {
        staticClass: "spring-nav-desktop__menu-item-inner",
        attrs: {
          "href": _vm.addTrackingParams(nav.link),
          "target": _vm.target
        }
      }, [_c('span', {
        staticClass: "spring-nav-desktop__menu-item-title",
        attrs: {
          "data-text": nav.title
        }
      }, [_vm._v("\n          " + _vm._s(nav.title) + "\n        ")])]), _vm._v(" "), nav.children ? _c('div', {
        staticClass: "spring-nav-desktop__dropdown",
        class: {
          'spring-nav-desktop__dropdown--show': _vm.isOpen(nav)
        }
      }, [_c('div', {
        staticClass: "spring-nav-desktop__dropdown-inner"
      }, [nav.isBox ? _c('SpringNavListBox', {
        attrs: {
          "items": nav.children
        },
        on: {
          "click": _vm.closeNav
        }
      }) : _c('SpringNavListRegular', {
        attrs: {
          "items": nav.children
        },
        on: {
          "click": _vm.closeNav
        }
      })], 1)]) : _vm._e()]);
    }), 0) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'SpringNavDesktop',
  components: {
    SpringNavListBox,
    SpringNavListRegular
  },
  mixins: [tracking],
  props: {
    navigation: {
      type: Array,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: ''
    },
    useEasyLogo: {
      type: Boolean,
      default: false
    },
    hideMenu: {
      type: Boolean,
      default: false
    },
    easyLogo: {
      type: String,
      default: ''
    },
    minisiteUrl: {
      type: String,
      default: '/'
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    menuLogo() {
      return this.useEasyLogo ? this.easyLogo : this.logo;
    },
    logoWidth() {
      return this.useEasyLogo ? 'w-160' : 'w-85';
    },
    variantStyles() {
      return {
        'spring-nav-desktop--v2': this.variant === 'v2'
      };
    }
  },
  methods: {
    isOpen(nav) {
      var _nav$open;
      return (_nav$open = nav.open) === null || _nav$open === void 0 ? void 0 : _nav$open.desktop;
    },
    closeNav() {
      this.$emit('close', 'desktop');
    },
    openNav(index) {
      this.$emit('open', 'desktop', index);
    },
    toggleNav(index) {
      this.$emit('toggle', 'desktop', index);
    }
  }
};

var css_248z$1 = ".spring-nav-mobile{width:100%}@media (min-width:1200px){.spring-nav-mobile{display:none}}.spring-nav-mobile__logo{-ms-flex-align:center;-ms-flex-pack:center;-webkit-align-items:center;align-items:center;cursor:pointer;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:center;justify-content:center;position:relative;z-index:50}.spring-nav-mobile__header{margin-left:auto;margin-right:auto;padding-left:30px;padding-right:30px}@media (min-width:600px){.spring-nav-mobile__header{padding-left:80px;padding-right:80px}}@media (min-width:900px){.spring-nav-mobile__header{max-width:1280px}}@media (min-width:1200px){.spring-nav-mobile__header{padding-left:40px;padding-right:40px}}.spring-nav-mobile__header{-ms-flex-align:center;-ms-flex-pack:justify;-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:space-between;justify-content:space-between;width:100%}.spring-nav-mobile__menu{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));height:100%;left:0;padding-top:60px;position:fixed;top:0;width:100%;z-index:-1}@media (min-width:600px){.spring-nav-mobile__menu{--tw-shadow:0 5px 20px 0 rgba(115,120,216,.15);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);left:auto;margin-top:0;padding-top:90px;right:0;top:0;width:515px;z-index:30}}.spring-nav-mobile__menu-inner{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));height:100%;overflow:auto}@media (min-width:600px){.spring-nav-mobile__menu-inner{padding:90px;padding-right:80px;padding-top:0}}.spring-nav-mobile__menu-item{--tw-bg-opacity:1;--tw-border-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));border-bottom-width:1px;border-color:rgba(230,230,230,var(--tw-border-opacity));padding:15px 30px}.spring-nav-mobile__menu-item:last-child{border-width:0}@media (min-width:600px){.spring-nav-mobile__menu-item:last-child{padding-left:0;padding-right:0}}.spring-nav-mobile__menu-item-inner{-ms-flex-align:center;-ms-flex-pack:justify;-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-ms-flexbox;display:flex;font-size:20px;font-weight:600;-webkit-justify-content:space-between;justify-content:space-between;line-height:26px;width:100%}.spring-nav-mobile__menu-dropdown{margin-top:20px}.spring-nav-mobile--v2 .spring-nav-mobile__hamburger{display:none}.spring-nav-mobile--v2 .spring-nav-mobile__logo{cursor:default}.spring-nav-mobile--v2 .spring-nav-mobile__logo img{width:120px}";
styleInject(css_248z$1);

var css_248z = ".spring-hamburger{-ms-flex-align:center;-webkit-align-items:center;align-items:center;cursor:pointer;height:20px;position:relative;width:20px;z-index:40}.spring-hamburger__icon{--tw-rotate:0deg;height:15px;height:100%!important;left:0;opacity:1;position:absolute;top:0;-webkit-transform:var(--tw-transform);transform:var(--tw-transform);transition-property:none;width:15px;width:100%!important;z-index:10}.spring-hamburger-close-enter-active,.spring-hamburger-close-leave-active,.spring-hamburger-open-enter-active,.spring-hamburger-open-leave-active{transition:all 175ms ease-out}.hamburger-open-leave-to,.spring-hamburger-open-enter{opacity:0}.spring-hamburger-open-enter{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.spring-hamburger-open-leave-to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.hamburger-close-leave-to,.spring-hamburger-close-enter{opacity:0;transition:all 175ms ease-out}.spring-hamburger-close-enter{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.spring-hamburger-close-leave-to{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}";
styleInject(css_248z);

var SpringNavHamburger = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "lg:hidden"
    }, [_c('button', {
      staticClass: "spring-hamburger",
      on: {
        "click": _vm.toggle
      }
    }, [_c('transition', {
      attrs: {
        "name": _vm.hamburgerTransition
      }
    }, [!_vm.open ? _c('font-awesome-icon', {
      key: "bars",
      staticClass: "spring-hamburger__icon spring-hamburger__icon--bars",
      attrs: {
        "icon": ['fas', 'bars']
      }
    }) : _c('font-awesome-icon', {
      key: "times",
      staticClass: "spring-hamburger__icon spring-hamburger__icon--times",
      attrs: {
        "icon": ['fas', 'xmark']
      }
    })], 1)], 1), _vm._v(" "), _vm.open ? _c('SpringBackdrop', {
      staticClass: "hidden sm:block",
      attrs: {
        "transparent": ""
      },
      on: {
        "click": _vm.toggle
      }
    }) : _vm._e()], 1);
  },
  staticRenderFns: [],
  name: 'SpringNavHamburger',
  components: {
    SpringBackdrop
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    hamburgerTransition() {
      return this.open ? 'spring-hamburger-open' : 'spring-hamburger-close';
    }
  },
  methods: {
    toggle() {
      this.$emit('click');
    }
  }
};

var SpringNavMobile = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "spring-nav-mobile",
      class: _vm.variantStyles
    }, [_c('div', {
      staticClass: "spring-nav-mobile__header"
    }, [!_vm.variant ? _c('a', {
      attrs: {
        "href": _vm.addTrackingParams(_vm.minisiteUrl),
        "target": _vm.target
      }
    }, [_c('img', {
      staticClass: "spring-nav-mobile__logo",
      class: _vm.logoWidth,
      attrs: {
        "src": _vm.menuLogo,
        "alt": "Spring Financial logo",
        "width": "85",
        "height": "30"
      },
      on: {
        "click": _vm.closeMenu
      }
    })]) : _vm.variant === 'v2' ? _c('img', {
      staticClass: "spring-nav-mobile__logo",
      class: _vm.logoWidth,
      attrs: {
        "src": _vm.menuLogo,
        "alt": "Spring Financial logo",
        "width": "85",
        "height": "30"
      },
      on: {
        "click": _vm.closeMenu
      }
    }) : _vm._e(), _vm._v(" "), !_vm.hideMenu ? _c('SpringNavHamburger', {
      staticClass: "spring-nav-mobile__hamburger",
      attrs: {
        "open": _vm.isExpanded
      },
      on: {
        "click": _vm.toggleMenu
      }
    }) : _vm._e()], 1), _vm._v(" "), _vm.isExpanded && !_vm.hideMenu ? _c('div', {
      staticClass: "spring-nav-mobile__menu"
    }, [_c('div', {
      staticClass: "spring-nav-mobile__menu-inner"
    }, [_c('ul', _vm._l(_vm.navigation, function (nav, index) {
      return _c('li', {
        key: index,
        staticClass: "spring-nav-mobile__menu-item"
      }, [nav.children ? _c('button', {
        staticClass: "spring-nav-mobile__menu-item-inner",
        on: {
          "click": function ($event) {
            return _vm.toggleNav(index);
          },
          "keydown": function ($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            return _vm.toggleNav(index);
          }
        }
      }, [_c('span', [_vm._v(_vm._s(nav.title))]), _vm._v(" "), _c('font-awesome-icon', {
        key: "angle-down",
        attrs: {
          "icon": ['fas', _vm.isOpen(nav) ? 'angle-up' : 'angle-down'],
          "size": "lg"
        }
      })], 1) : _c('a', {
        staticClass: "spring-nav-mobile__menu-item-inner",
        attrs: {
          "href": _vm.addTrackingParams(nav.link),
          "target": _vm.target
        },
        on: {
          "click": function ($event) {
            return _vm.closeNav(index);
          }
        }
      }, [_c('span', [_vm._v(_vm._s(nav.title))])]), _vm._v(" "), _vm.isOpen(nav) ? _c('div', {
        staticClass: "spring-nav-mobile__menu-dropdown"
      }, [nav.isBox ? _c('SpringNavListBox', {
        attrs: {
          "items": nav.children
        },
        on: {
          "click": function ($event) {
            return _vm.closeNav(index);
          }
        }
      }) : _c('SpringNavListRegular', {
        attrs: {
          "items": nav.children
        },
        on: {
          "click": function ($event) {
            return _vm.closeNav(index);
          }
        }
      })], 1) : _vm._e()]);
    }), 0)])]) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'SpringNavMobile',
  components: {
    SpringNavHamburger,
    SpringNavListBox,
    SpringNavListRegular
  },
  mixins: [tracking],
  props: {
    navigation: {
      type: Array,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: ''
    },
    hideMenu: {
      type: Boolean,
      default: false
    },
    useEasyLogo: {
      type: Boolean,
      default: false
    },
    easyLogo: {
      type: String,
      default: ''
    },
    minisiteUrl: {
      type: String,
      default: '/'
    },
    variant: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    menuLogo() {
      return this.useEasyLogo ? this.easyLogo : this.logo;
    },
    logoWidth() {
      return this.useEasyLogo ? 'w-130' : 'w-70 sm:w-100';
    },
    variantStyles() {
      return {
        'spring-nav-mobile--v2': this.variant === 'v2'
      };
    }
  },
  methods: {
    toggleMenu() {
      this.isExpanded = !this.isExpanded;
      this.toggleScroll();
    },
    closeMenu() {
      this.isExpanded = false;
      this.toggleScroll();
    },
    toggleScroll() {
      this.$emit('expanded', this.isExpanded);
      if (this.isExpanded) {
        document.body.classList.add('scroll-disabled-mobile');
      } else {
        document.body.classList.remove('scroll-disabled-mobile');
      }
    },
    isOpen(nav) {
      var _nav$open;
      return (_nav$open = nav.open) === null || _nav$open === void 0 ? void 0 : _nav$open.mobile;
    },
    closeNav(index) {
      this.toggleMenu();
      this.$emit('close', 'mobile', index);
    },
    openNav(index) {
      this.$emit('open', 'mobile', index);
    },
    toggleNav(index) {
      this.$emit('toggle', 'mobile', index);
    }
  }
};

var SpringNav = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "spring-header__wrapper"
    }, [_c('nav', {
      staticClass: "spring-nav",
      class: Object.assign({}, {
        'spring-nav--float': _vm.showBg,
        'spring-nav--drop-nav': _vm.dropNav && !_vm.isExpanded
      }, _vm.variantStyles)
    }, [_c('SpringNavDesktop', {
      attrs: {
        "navigation": _vm.navigation,
        "logo": _vm.logo,
        "use-easy-logo": _vm.useEasyLogo,
        "easy-logo": _vm.easyLogo,
        "hide-menu": _vm.hideMenu,
        "target": _vm.target,
        "variant": _vm.variant
      },
      on: {
        "close": _vm.closeNav,
        "open": _vm.openNav,
        "toggle": _vm.toggleNav
      }
    }), _vm._v(" "), _c('SpringNavMobile', {
      attrs: {
        "navigation": _vm.navigation,
        "logo": _vm.logo,
        "use-easy-logo": _vm.useEasyLogo,
        "easy-logo": _vm.easyLogo,
        "hide-menu": _vm.hideMenu,
        "target": _vm.target,
        "variant": _vm.variant
      },
      on: {
        "expanded": _vm.mobileExpanded,
        "close": _vm.closeNav,
        "open": _vm.openNav,
        "toggle": _vm.toggleNav
      }
    })], 1)]);
  },
  staticRenderFns: [],
  name: 'SpringNav',
  components: {
    SpringNavDesktop,
    SpringNavMobile
  },
  props: {
    logo: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: ''
    },
    hideMenu: {
      type: Boolean,
      default: false
    },
    easyLogo: {
      type: String,
      default: ''
    },
    updateLendfulDisclosure: {
      type: Boolean,
      default: false
    },
    dropNav: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showBg: false,
      useEasyLogo: false,
      isExpanded: false,
      navigation: [{
        title: 'Products',
        isBox: true,
        open: {
          desktop: false,
          mobile: false
        },
        children: [{
          title: 'Personal Loan',
          description: `Same-day personal loans up to ${this.updateLendfulDisclosure ? '$35,000' : '$15,000'}.`,
          link: '/personal-loans',
          theme: 'blue'
        }, {
          title: 'The Foundation',
          description: 'Credit building on autopilot.',
          link: '/foundation',
          theme: 'purple'
        }, {
          title: 'Evergreen Loan',
          description: 'A stress-free, responsible way to borrow money.',
          link: '/evergreen-loan',
          theme: 'green'
        }, {
          title: 'Mortgages',
          description: 'Full suite of options for new or existing homeowners.',
          link: '/mortgages',
          theme: 'pink'
        }]
      }, {
        title: 'Reviews',
        link: '/reviews'
      }, {
        title: 'Blog',
        link: '/blog'
      }, {
        title: 'About',
        open: {
          desktop: false,
          mobile: false
        },
        children: [{
          title: 'Who We Are',
          link: '/about-spring-financial'
        }, {
          title: 'Work With Us',
          link: '/careers'
        }]
      }, {
        title: 'Help Centre',
        link: '/help-centre'
      }]
    };
  },
  computed: {
    foundationEligibleOnly() {
      return this.$store.getters.isFoundationEligibleOnly;
    },
    flinksCompleted() {
      return this.$store.state.documents.bankStatements;
    },
    variantStyles() {
      return {
        'spring-nav--v2': this.variant === 'v2'
      };
    }
  },
  beforeUpdate() {
    // if we are already using easy logo and it switches to decline PL flow
    // remove easy logo
    if (this.useEasyLogo && this.foundationEligibleOnly && this.flinksCompleted) this.useEasyLogo = false;
  },
  created() {
    // use easy financial logo for credit karma personal loans
    const {
      query,
      path
    } = this.$route;
    const SID = query.SID;
    if (SID === 'creditkarma' && path.includes('personal-loans')) this.useEasyLogo = true;
  },
  mounted() {
    this.show = true;
    this.handleScroll();
    this.handleBg();
  },
  methods: {
    handleScroll() {
      window.onscroll = () => {
        this.handleBg();
      };
    },
    handleBg() {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 5) this.showBg = true;else this.showBg = false;
    },
    closeNav(device, index) {
      // Reset all 'open' states.
      this.navigation = this.navigation.map((item, idx) => {
        if (item.children) {
          let isOpen = false;

          // Keep the dropdown open on mobile if
          // the index matches the item index.
          if (device === 'mobile') isOpen = idx === index;
          item.open[device] = isOpen;
        }
        return item;
      });
    },
    openNav(device, index) {
      this.navigation[index].open[device] = true;
    },
    toggleNav(device, index) {
      const isOpen = this.navigation[index].open[device];
      this.navigation[index].open[device] = !isOpen;
    },
    mobileExpanded(expanded) {
      this.isExpanded = expanded;
    }
  }
};

export { SpringNav as S, SpringNavHamburger as a, SpringNavMobile as b, SpringNavDesktop as c };
